import { observer } from "mobx-react-lite";

import { shouldUseTagInput, OperatorType } from "../constants";

import SourceInput from "./SourceInput";
import StaticInput from "./StaticInput";
import TagStaticInput from "./TagStaticInput";

import { ValueConfig } from "@/components/Workflows/types";

interface ConditionValueProps {
  value: ValueConfig | string;
  onChange?: (value: ValueConfig) => void;
  className?: string;
  placeholder?: string;
  readonly?: boolean;
  operator?: OperatorType;
  isLeftSide?: boolean;
}

const ConditionValueInput = ({
  value,
  onChange,
  className,
  placeholder,
  readonly,
  operator,
  isLeftSide = false,
}: ConditionValueProps) => {
  const handleSourceSwitch = (e: React.MouseEvent) => {
    e.preventDefault();
    onChange?.({ source: { name: "", json_path: null } });
  };

  const handleStaticSwitch = (e: React.MouseEvent) => {
    e.preventDefault();
    onChange?.({ static_value: "" });
  };

  const staticProps = {
    className,
    placeholder,
    onChange,
    onSourceSwitch: handleSourceSwitch,
    readonly,
  };

  // Extract static value from various input types
  const getStaticValue = (): string | null => {
    if (typeof value === "string") {
      return value;
    }
    if (typeof value === "object" && "static_value" in value) {
      return value.static_value;
    }
    return null;
  };

  const staticValue = getStaticValue();

  // Handle source input
  if (typeof value === "object" && "source" in value) {
    return (
      <SourceInput
        source={value.source}
        onChange={onChange}
        onStaticSwitch={handleStaticSwitch}
        readonly={readonly}
      />
    );
  }

  // Handle static input (either string or static_value)
  if (staticValue !== null) {
    const InputComponent =
      operator && shouldUseTagInput(operator) && !isLeftSide ? TagStaticInput : StaticInput;
    return <InputComponent inputValue={staticValue} {...staticProps} />;
  }

  return null;
};

export default observer(ConditionValueInput);
